import { actionCreator } from '../action-created'
import { NEW_BRDC, ADD_BRDC, DEL_BRDC } from './key'

export const newBrdc = (payload) => actionCreator(NEW_BRDC, payload)
export const addBrdc = (payload) => actionCreator(ADD_BRDC, payload)
export const delBrdc = (payload) => actionCreator(DEL_BRDC, payload)